import React from "react";
import { DEFAULT_AVATAR, SKIN_TONES, HAIR_COLORS, OUTFIT_COLORS } from "@/data/avatarData";
import { HairBack, HairFront, Outfit, Accessory } from "./avatarParts";

const Avatar = ({ avatar, size = 120, className = "", testid = "avatar-svg" }) => {
  const a = { ...DEFAULT_AVATAR, ...(avatar || {}) };
  const skin = SKIN_TONES[a.skin] || SKIN_TONES[1];
  const hair = HAIR_COLORS[a.hairColor] || HAIR_COLORS[0];
  const outfit = OUTFIT_COLORS[a.outfitColor] || OUTFIT_COLORS[0];
  const boy = a.look !== "girl";

  return (
    <svg
      viewBox="0 0 200 240"
      width={size}
      height={size * 1.2}
      className={className}
      data-testid={testid}
      data-look={boy ? "boy" : "girl"}
      aria-label="Your avatar"
    >
      <HairBack style={a.hairStyle} color={hair} />
      <Outfit style={a.outfit} color={outfit} skin={skin} />
      <rect x="86" y="132" width="28" height="26" rx="8" fill={skin} />
      <circle cx="45" cy="97" r="10" fill={skin} />
      <circle cx="155" cy="97" r="10" fill={skin} />
      {boy ? (
        <path d="M45 95 A55 55 0 0 1 155 95 L154 118 Q152 150 100 152 Q48 150 46 118 Z" fill={skin} />
      ) : (
        <circle cx="100" cy="95" r="55" fill={skin} />
      )}
      {/* eyes */}
      <ellipse cx="82" cy="94" rx={boy ? 8 : 9} ry={boy ? 9 : 11} fill="#fff" />
      <ellipse cx="118" cy="94" rx={boy ? 8 : 9} ry={boy ? 9 : 11} fill="#fff" />
      <circle cx="84" cy="96" r="5" fill="#1E293B" />
      <circle cx="120" cy="96" r="5" fill="#1E293B" />
      <circle cx="86" cy="93" r="2" fill="#fff" />
      <circle cx="122" cy="93" r="2" fill="#fff" />
      {boy ? (
        <g stroke={hair} strokeWidth="5" strokeLinecap="round" fill="none">
          <path d="M70 78 L92 76" />
          <path d="M108 76 L130 78" />
        </g>
      ) : (
        <g>
          <path d="M72 78 Q82 72 92 78" stroke={hair} strokeWidth="3.5" fill="none" strokeLinecap="round" />
          <path d="M108 78 Q118 72 128 78" stroke={hair} strokeWidth="3.5" fill="none" strokeLinecap="round" />
          <g stroke="#1E293B" strokeWidth="2" strokeLinecap="round">
            <line x1="73" y1="88" x2="68" y2="84" /><line x1="72" y1="94" x2="67" y2="93" />
            <line x1="127" y1="88" x2="132" y2="84" /><line x1="128" y1="94" x2="133" y2="93" />
          </g>
        </g>
      )}
      {/* cheeks + smile */}
      {boy ? (
        <g fill="#B45309" opacity="0.45">
          <circle cx="66" cy="112" r="1.6" /><circle cx="72" cy="116" r="1.6" /><circle cx="60" cy="117" r="1.6" />
          <circle cx="134" cy="112" r="1.6" /><circle cx="128" cy="116" r="1.6" /><circle cx="140" cy="117" r="1.6" />
        </g>
      ) : (
        <g fill="#F9A8D4" opacity="0.7">
          <circle cx="66" cy="112" r="7" />
          <circle cx="134" cy="112" r="7" />
        </g>
      )}
      {boy ? (
        <path d="M82 118 Q100 136 118 118 Z" fill="#7C2D12" />
      ) : (
        <path d="M84 118 Q100 136 116 118" stroke="#DB2777" strokeWidth="4" fill="none" strokeLinecap="round" />
      )}
      <HairFront style={a.hairStyle} color={hair} />
      <Accessory type={a.accessory} color={outfit} />
    </svg>
  );
};

export default Avatar;
